// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,ts_nocheck=true"
// @generated from file actions/v1/workflow_run_delete_warning.proto (package github.actions.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file actions/v1/workflow_run_delete_warning.proto.
 */
export const file_actions_v1_workflow_run_delete_warning: GenFile = /*@__PURE__*/
  fileDesc("CixhY3Rpb25zL3YxL3dvcmtmbG93X3J1bl9kZWxldGVfd2FybmluZy5wcm90bxIRZ2l0aHViLmFjdGlvbnMudjEicQogV29ya2Zsb3dSdW5EZWxldGVXYXJuaW5nUmVzcG9uc2USTQoNcHVsbF9yZXF1ZXN0cxgBIAMoCzI2LmdpdGh1Yi5hY3Rpb25zLnYxLldvcmtmbG93UnVuRGVsZXRlV2FybmluZ1B1bGxSZXF1ZXN0ImIKI1dvcmtmbG93UnVuRGVsZXRlV2FybmluZ1B1bGxSZXF1ZXN0Eg4KBm51bWJlchgBIAEoBRINCgV0aXRsZRgCIAEoCRILCgN1cmwYAyABKAkSDwoHaXNfb3BlbhgEIAEoCGIGcHJvdG8z");

/**
 * Advisory response for an explicit JSON request to
 * GET /:owner/:repo/actions/runs/:workflow_run_id/delete_pull_requests_list.
 *
 * @generated from message github.actions.v1.WorkflowRunDeleteWarningResponse
 */
export type WorkflowRunDeleteWarningResponse = Message<"github.actions.v1.WorkflowRunDeleteWarningResponse"> & {
  /**
   * @generated from field: repeated github.actions.v1.WorkflowRunDeleteWarningPullRequest pull_requests = 1;
   */
  pullRequests: WorkflowRunDeleteWarningPullRequest[];
};

/**
 * Describes the message github.actions.v1.WorkflowRunDeleteWarningResponse.
 * Use `create(WorkflowRunDeleteWarningResponseSchema)` to create a new message.
 */
export const WorkflowRunDeleteWarningResponseSchema: GenMessage<WorkflowRunDeleteWarningResponse> = /*@__PURE__*/
  messageDesc(file_actions_v1_workflow_run_delete_warning, 0);

/**
 * @generated from message github.actions.v1.WorkflowRunDeleteWarningPullRequest
 */
export type WorkflowRunDeleteWarningPullRequest = Message<"github.actions.v1.WorkflowRunDeleteWarningPullRequest"> & {
  /**
   * @generated from field: int32 number = 1;
   */
  number: number;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string url = 3;
   */
  url: string;

  /**
   * @generated from field: bool is_open = 4;
   */
  isOpen: boolean;
};

/**
 * Describes the message github.actions.v1.WorkflowRunDeleteWarningPullRequest.
 * Use `create(WorkflowRunDeleteWarningPullRequestSchema)` to create a new message.
 */
export const WorkflowRunDeleteWarningPullRequestSchema: GenMessage<WorkflowRunDeleteWarningPullRequest> = /*@__PURE__*/
  messageDesc(file_actions_v1_workflow_run_delete_warning, 1);

import { registerSchemaHash } from "../../../schema-hash-registry";
registerSchemaHash(WorkflowRunDeleteWarningResponseSchema, "cce956b57bfb")
registerSchemaHash(WorkflowRunDeleteWarningPullRequestSchema, "6b4a8f2484b0")
